import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs/Rx';

@Injectable()
export class ModalIframeService {
    public subject = new Subject();
    public openModalListener$ = this.subject.asObservable();
    constructor() { }

    public getModalListener(){
        return this.openModalListener$;
    }

    public openModalIframe(){
        this.subject.next();
    }
}


// WEBPACK FOOTER //
// ./src/app/common/iframe/modal-iframe.service.ts